import $ from 'jquery';
window.$ = $;
window.jQuery = $;

import Cookies from 'js-cookie';
window.Cookies = Cookies;



// WEBPACK FOOTER //
// ./app/assets/granite/js/jquery.js